module.exports = __webpack_public_path__ + "static/media/9.de73abcf.JPG";